import { render, staticRenderFns } from "./yes-no.vue?vue&type=template&id=d07f38f2&scoped=true"
import script from "./yes-no.vue?vue&type=script&lang=js"
export * from "./yes-no.vue?vue&type=script&lang=js"
import style0 from "./yes-no.vue?vue&type=style&index=0&id=d07f38f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07f38f2",
  null
  
)

export default component.exports